// Core & Styles
import * as React from "react";
import * as ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

// Layouts
import App from "./App";
import Layout from "./layouts/Layout";
import AuthLayout from "./auth/Layout";

// Authentication Pages
import Login from "./auth/Login";
import Register from "./auth/Register";

// Dashboard
import Dashboard from "./pages/Dashboard";

// Products
import Products from "./pages/products/index";
import AddProduct from "./pages/products/AddProduct";
import ListProducts from "./pages/products/Products";
import StepPrice from "./pages/products/StepPrice";

// Users
import Users from "./pages/users/index";
import ListUsers from "./pages/users/Users";

// Branches
import Branches from "./pages/branches/index";
import AddBranch from "./pages/branches/AddBranch";
import ListBranches from "./pages/branches/ListBranch";
import StockBranch from "./pages/branches/Stock";
import Pricing from "./pages/branches/Pricing";

// Branches - Stock
import Stock from "./pages/stock/index";

// Categories
import Categories from "./pages/categories/index";
import ListCategories from "./pages/categories/ListCategories";

// Reports
import Reports from "./pages/reports/index";
import ListReports from "./pages/reports/ListReports";
import Transaction from "./pages/reports/Transaction";

// Groups
import Groups from "./pages/groups/index";
import ListGroups from "./pages/groups/ListGroups";
import PricingGroups from "./pages/groups/Pricing";

// Permissions
import Permissions from "./pages/permissions/index";
import PermissionTable from "./pages/permissions/PermissionTable";

const router = createBrowserRouter([
  {
    Component: App,
    children: [
      {
        path: "/",
        Component: Layout,
        children: [
          {
            path: "/",
            Component: ListProducts,
          },
          {
            path: "/products",
            Component: Products,
            children: [
              {
                path: "",
                Component: ListProducts,
              },
              {
                path: "add",
                Component: AddProduct,
              },
              {
                path: "step-price",
                Component: StepPrice,
              },
            ],
          },
          {
            path: "/step-price",
            Component: StepPrice,
          },
          {
            path: "/categories",
            Component: Categories,
            children: [
              {
                path: "",
                Component: ListCategories,
              },
              // {
              //   path: 'add',
              //   Component: AddProduct,
              // },
            ],
          },
          {
            path: "/branches",
            Component: Branches,
            children: [
              {
                path: "",
                Component: ListBranches,
              },
              {
                path: "add",
                Component: AddBranch,
              },
              {
                path: "pricing/:branchId",
                Component: Pricing,
              },
              {
                path: "stock/:branchId",
                Component: StockBranch,
              },
            ],
          },
          {
            path: "/users",
            Component: Users,
            children: [
              {
                path: "",
                Component: ListUsers,
              },
            ],
          },
          {
            path: "/groups",
            Component: Groups,
            children: [
              {
                path: "",
                Component: ListGroups,
              },
              {
                path: "pricing/:id",
                Component: PricingGroups,
              },
            ],
          },
          {
            path: "/reports",
            Component: Reports,
            children: [
              {
                path: "",
                Component: ListReports,
              },
              {
                path: ":transactionId",
                Component: Transaction,
              },
            ],
          },
          {
            path: "/stock",
            Component: Stock,
          },
          {
            path: "/permissions",
            Component: Permissions,
            children: [
              {
                path: "",
                Component: PermissionTable,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/auth",
    Component: AuthLayout,
    children: [
      {
        path: "login",
        Component: Login,
      },
      {
        path: "register",
        Component: Register,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <RouterProvider router={router} />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
